import React from "react";

import { MoodWrapper } from "../../container/accountSettings.styles";

import { changeMood } from "../../../../Header/store/headerSlice";
import { Switch as AntSwitch } from "antd";
import styled from "styled-components";
import MoodIcon from "../../../../assets/icon/mood.svg";

import { useAppDispatch } from "@features/store/store";
import { useCurrentTheme } from "Header/store/selector";
import { LightMode } from "Header/styled";

const SwitchMood = styled(AntSwitch)`
    .ant-switch-handle::before {
        content: "";
        display: block;
        background-image: url(${MoodIcon});
        background-size: cover;
        background-position: center;
    }
`;

const Mood: React.FC = () => {
    const dispatch = useAppDispatch();
    const themeMode = useCurrentTheme();

    const selectMood = () => {
        dispatch(changeMood());
    };

    return (
        <MoodWrapper>
            <SwitchMood checked={themeMode === "dark"} onChange={selectMood} />
            <LightMode align="right">{themeMode === "dark" ? "Dark mode" : "Light mode"}</LightMode>
        </MoodWrapper>
    );
};

export default Mood;
